export class Queue<T> {

    items: LinkedList<T> | null = null;

    constructor() {
        this.items = new LinkedList<T>();
    }

    enqueue = (item: T): void => {
        this.items?.addFirst(item);
    }

    dequeue = (): T | null | undefined => {
        let last = this.items?.getLast();
        if (last) this.items?.deleteNode(last);
        // console.log('inside queue ' ,this.items)
        return last?.data;
    }

    dequeueObject = (object: T): T | null | undefined => {
        return this.items?.removeObject(object);
    }

    peek = (): T | null | undefined => {
        return this.items?.getLast()?.data;
    }

}

class Node<T> {
    public next: Node<T> | null = null;
    public prev: Node<T> | null = null;
    public data: T | null = null;

    constructor(data: T) {
        this.data = data;
    }
}

class LinkedList<T> {
    private head: Node<T> | null = null;
    private tail: Node<T> | null = null;

    public getLast(): Node<T> | null {
        return this.tail;
    }

    public getFirst(): Node<T> | null {
        return this.head;
    }

    public addLast(data: T): Node<T> {
        const node = new Node(data);
        if (!this.tail) {
            this.head = node;
            this.tail = node;
        } else {
            this.tail.next = node; //muta
            node.prev = this.tail; //set
            this.tail = node;
        }
        return node;
    }

    public addFirst(data: T): Node<T> {
        const node = new Node(data);
        if (!this.head) {
            this.head = node;
            this.tail = node;
        } else {
            this.head.prev = node; //muta
            node.next = this.head; //set
            this.head = node;
        }
        return node;
    }

    public deleteNode(node: Node<T>): void {
        if (!node.prev) {
            this.head = node.next;
        } else {
            const prevNode = node.prev;
            prevNode.next = node.next;
        }
        if (!node.next) {
            this.tail = node.prev;
        }
    }

    public removeObject(data: T): T | null {
        if (!this.head) {
            return null; // list is empty
        }

        let currentNode: Node<T> | null = this.head;

        while (!!currentNode) {
            if (currentNode.data === data) {
                // Node to be removed is found
                this.deleteNode(currentNode);
                return currentNode.data;
            }

            currentNode = currentNode.next;
        }

        return null; // object wasn't found
    }


}
